import React from 'react'
import { FormikProps } from 'formik'

import { Alert, Input } from '@dgshahr/ui-kit'

import ShamsiDatepicker from '@/components/common/components/ShamsiDatepicker'
import { individualUserFields } from '@/data/merchant-register-forms/InfoStep'
import { StoreType, TInfoFormValues } from '@/types/infoStep'

interface IIndividualFormProps {
  formik: FormikProps<TInfoFormValues>
}

export const IndividualForm = ({ formik }: IIndividualFormProps) => {
  const { values, touched, errors, setFieldValue, handleChange, handleBlur } =
    formik

    return (
    <div>
      <section className="mt-4 p-4 flex flex-col gap-8 desktop:grid desktop:grid-cols-3">
        {individualUserFields.map((field) => (
          <React.Fragment key={field.id}>
            {field.datePicker ? (
              <ShamsiDatepicker
                id={field.id}
                name={field.name}
                labelContent={field.labelContent}
                errorMessage={
                  (touched[field.name] && errors[field.name]) || ''
                }
                value={values.licenseExpirationDate ?? null}
                onChange={(date) => setFieldValue(field.name, date)}
              />
            ) : (
              <Input
                required={
                  field.name === 'storeName' ||
                  (field.name === 'website' &&
                    (values.type === StoreType.ONLINE ||
                      values.type === StoreType.BOTH))
                }
                key={field.id}
                name={field.name}
                placeholder={field.placeholder}
                id={field.id}
                postfix={field.postFix}
                dir={field.postFix ? 'ltr' : 'rtl'}
                onChange={(e) => {
                  if (field.name === 'website') {
                    setFieldValue(
                      'website',
                      e.target.value.replace(/^https?:\/\//i, '')
                    )
                    return
                  }
                  handleChange(e)
                }}
                onClear={() => setFieldValue(field.name, '')}
                onBlur={handleBlur}
                value={
                  !field.datePicker ? String(values[field.name] ?? '') : ''
                }
                labelContent={field.labelContent}
                type={field.type}
                errorMessage={(touched[field.name] && errors[field.name]) || ''}
              />
            )}
          </React.Fragment>
        ))}
      </section>
    </div>
  )
}
